import React, {Component} from 'react';
import DateTimeFormatter from "../../helpers/DateTimeFormatter";
import {onCarrierLogoError} from "../../helpers/CarrierLogoFallback";
import md5 from 'js-md5';
import SegmentTransport from '../common/SegmentTransport';

export const SEGMENT_DIRECTION = {
    SEGMENT_DIRECT: 'flight-direct',
    SEGMENT_STOP: 'flight-stop',
    SEGMENT_STOP_START: 'flight-stop-start',
    SEGMENT_STOP_END: 'flight-stop-end'
};

export default class Segment extends Component {
    render() {
        const translator = this.props.translator;
        const segment = this.props.segment;

        let segmentKey = md5(JSON.stringify(segment)) + Math.random().toString(36).substr(2, 9);
        let durationHours = DateTimeFormatter.secsToTimeParts(segment.duration)[0];
        let durationMinutes = DateTimeFormatter.secsToTimeParts(segment.duration)[1];

        const durationText = DateTimeFormatter.timeFormat(
            durationHours,
            durationMinutes,
            translator.trans('h.'),
            translator.trans('m.')
        );

        return (
            <div className="ff-seg">
                <div className="ff-seg__air">
                    <span className="ff-seg__logo">
                        <img alt={segment.carrier} src={`/assets/cdn/flights/carriers/xsmall/${segment.carrier}.png`}
                             id={`segment-title-${segmentKey}`} onError={onCarrierLogoError}/>
                    </span>
                    <div>
                        <div className="ff-seg__carrier">{segment.carrierName}</div>
                        <div className="ff-seg__flightno num">{segment.flightNumber}</div>
                        <SegmentTransport segment={segment} translator={translator}/>
                    </div>
                </div>
                <div className="ff-seg__point">
                    <div className="ff-seg__time num">
                        {DateTimeFormatter.getTime(segment.departureTime)} <span className="ff-seg__code">{segment.departureAirport}</span>
                    </div>
                    <div className="ff-seg__airport">{segment.departureAirportName}</div>
                </div>
                <div className="ff-seg__mid">
                    <div className="ff-seg__dur num">{durationText}</div>
                    <div className="ff-seg__line"><span className="ff-seg__dot"/><span className="ff-seg__dot"/></div>
                </div>
                <div className="ff-seg__point ff-seg__point--end">
                    <div className="ff-seg__time num">
                        {DateTimeFormatter.getTime(segment.arrivalTime)} <span className="ff-seg__code">{segment.arrivalAirport}</span>
                    </div>
                    <div className="ff-seg__airport">{segment.arrivalAirportName}</div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/flights/Segment.js